import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBsm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M208 446q-3 0-7-4l-25-34q-5-6 0-12l5-6q6-6 12-6h350q17 0 28 3 9 3 14 7l3 4q4 6 7 3.5t1-7.5l-3-6q-5-6-14-9-11-6-28-6H135q-4 0-7-3t-3-7v-30q0-4 3-7t7-3h492q4 0 9 2.5t7 6.5l11 21q5 11 9 11h205q4 0 6 3t1 7l-5 13q-7 17-16 33-13 22-28 40-19 23-41 37-20 13-48 24-23 10-44.5 15t-25 3-5.5-9.5-7-6.5-5 12v1q0 4-2.5 5.5T637 545q-5 2-13 7-11 9-17 21-9 16-8.5 35.5T612 645q11 14 24.5 20t28.5 8q4 1 7 4t3 7v61q0 4-3 7t-7 3H557q-4 0-7-3t-3-7v-12q0-9-14.5-19T497 697t-37-7q-25 1-44 5-13 3-22 9l-7 4q-3 2-7 1l-3-2-4-7q-3-8-3-12 0-14 17-31 9-8 17-12t21-7.5 4-5.5h-6q-7 0-14 2-11 3-20 9-33 21-33 56v46q0 4-2.5 7t-6.5 3H241q-3 0-6-3t-3-7v-58q0-3 3.5-7.5t7.5-5.5l12-6q14-8 25-19 17-15 26-34 12-24 12-52 0-37-19-66-17-24-44-38-24-13-47-13z" })
});
export default SvgBsm;
